// export function updateDaywiseTripDate(itinerary: any, startDate: string) {
//   if (!itinerary) return null;
//   return {
//     ...itinerary,
//     city_wise_itinerary: itinerary?.city_wise_itinerary?.map((cityELE: any) =>
//       cityELE?.city_itinerary?.map((ele: any) => {
//         const match = ele?.day.match(/\d+/); // Matches any digit(s) in the string
//         let count = match ? parseInt(match[0], 10) - 1 : 0;
//         return {
//           ...ele,
//           date: getYYYYMMDD(
//             String(
//               new Date(
//                 new Date(startDate).setDate(
//                   new Date(startDate).getUTCDate() + count
//                 )
//               )
//             )
//           ),
//         };
//       })
//     ),
//   };
// }
import { PAX_TYPE } from "../component/BookingInProgress/utils/travelerHotelContextUtils";
// export function updateDaywiseTripDateForMetaData(
//   destinationList: any,
//   startDate: string
// ) {
//   if (!destinationList || destinationList?.length === 0) return null;
//   return destinationList?.map((destEle: any) => ({
//     ...destEle,
//     tripDetails: destEle?.tripDetails?.map((ele: any) => {
//       const match = ele?.day.match(/\d+/); // Matches any digit(s) in the string
//       let count = match ? parseInt(match[0], 10) - 1 : 0;
//       return {
//         ...ele,
//         date: getYYYYMMDD(
//           String(
//             new Date(
//               new Date(startDate).setDate(new Date(startDate).getUTCDate() + count)
//             )
//           )
//         ),
//       };
//     }),
//   }));
// }

// function getYYYYMMDD(dateStr: string) {
//   return new Date(dateStr).toLocaleDateString("en-CA");
// }

type Itinerary = {
  city_wise_itinerary?: CityItinerary[];
};

type CityItinerary = {
  city_itinerary?: DayItinerary[];
};

type DayItinerary = {
  day: string;
  date?: string;
};

type Destination = {
  tripDetails?: DayItinerary[];
};

const DAY_REGEX = /\d+/;

export function updateDaywiseTripDate(itinerary: Itinerary | null, startDate: string): Itinerary | null {
  if (!itinerary) return null;

  const parsedStartDate = new Date(startDate);

  return {
    ...itinerary,
    city_wise_itinerary: itinerary.city_wise_itinerary?.map((cityItinerary) => ({
      ...cityItinerary,
      city_itinerary: cityItinerary.city_itinerary?.map((dayItinerary) =>
        updateDayItineraryDate(dayItinerary, parsedStartDate)
      ),
    })),
  };
}

export const roundValue = (value: number) => Math.ceil(value ?? 0);

export const floorValue = (value: number) => Math.floor(value);

export const calculateNights = (checkIn: string, checkOut: string): number => {
  const checkInDate = new Date(checkIn);
  const checkOutDate = new Date(checkOut);
  const timeDifference = checkOutDate.getTime() - checkInDate.getTime();
  const nights = timeDifference / (1000 * 3600 * 24) || 0;
  return nights;
};

export function updateDaywiseTripDateForMetaData(
  destinationList: Destination[] | null,
  startDate: string
): Destination[] | null {
  if (!destinationList || destinationList.length === 0) return null;

  const parsedStartDate = new Date(startDate);

  return destinationList.map((destEle) => ({
    ...destEle,
    tripDetails: destEle.tripDetails?.map((dayItinerary) => updateDayItineraryDate(dayItinerary, parsedStartDate)),
  }));
}

function updateDayItineraryDate(dayItinerary: DayItinerary, startDate: Date): DayItinerary {
  const match = dayItinerary.day.match(DAY_REGEX);
  const count = match ? parseInt(match[0], 10) - 1 : 0;
  // const updatedDate = new Date(startDate);
  // updatedDate.setDate(startDate.getUTCDate() + count);
  const updatedDate = new Date(startDate);
  updatedDate.setDate(updatedDate.getDate() + count);

  return {
    ...dayItinerary,
    date: getYYYYMMDD(updatedDate),
  };
}

function getYYYYMMDD(date: Date): string {
  if (!date || isNaN(date.getTime())) return "";
  return date.toISOString().split("T")[0];
}

function calculateAge(dobStr: string, refDateStr?: string): number {
  // Parse the date of birth string into a Date object
  const dob = new Date(dobStr);
  // Age reference date: the passed travel date (e.g. the trip's last-leg
  // departure) when provided + valid, else today. Legacy callers pass no 2nd
  // arg → byte-identical (today).
  const parsedRef = refDateStr ? new Date(refDateStr) : null;
  const today = parsedRef && !Number.isNaN(parsedRef.getTime()) ? parsedRef : new Date();

  // Calculate the age
  let age = today.getFullYear() - dob.getFullYear();
  const monthDifference = today.getMonth() - dob.getMonth();

  // Adjust age if the birthday hasn't occurred yet this year
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  return age;
}

export enum PAXTYPE {
  ADULT = "ADT",
  CHILD = "CHD",
  INFANT = "INF",
}

export function getPaxTypeFunc(dateOfBirth: string, travelDate?: string): string {
  const age = calculateAge(dateOfBirth, travelDate);
  if (age < 2) return PAXTYPE.INFANT;
  if (age < 12) return PAXTYPE.CHILD;
  return PAXTYPE.ADULT;
}

export const getMonthDateFormat = (dateString: string): string => {
  // const options: Intl.DateTimeFormatOptions = {
  //   day: "2-digit",
  //   month: "short",
  //   timeZone: "UTC",
  // };
  if (!dateString) return "";
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const date = new Date(dateString);
  const month = months[date.getMonth()];
  const dayOfMonth = date.getDate();
  const formattedDate = `${month} ${dayOfMonth}`;
  return formattedDate;
};

export function attachInfantsToAdults(passengers: any[]) {
  try {
    const notInfants = passengers.filter(p => (p.paxType === PAX_TYPE.adult || p.paxType === PAX_TYPE.child));
    const infants = passengers.filter(p => p.paxType === PAX_TYPE.infant);

    if (!infants.length) {
      return notInfants.map(adult => ({ ...adult, infantData: null }));
    }

    const leadAdultIndex = notInfants.findIndex(p => p.leadPax === true);
    let infantIndex = 0;

    const updatedPassengers = notInfants.map((adult, index) => {
      let infant = null;

      if (index === leadAdultIndex && infantIndex < infants.length) {
        infant = infants[infantIndex++];
      } else if (index !== leadAdultIndex && infantIndex < infants.length) {
        infant = infants[infantIndex++];
      }

      return {
        ...adult,
        infantData: infant
          ? {
            ...infant,
            passengerId: index + 1,
          }
          : null,
      };
    });
    return updatedPassengers
  } catch {
    return passengers
  }
}

// CHILD passengers render no email/phone form fields, so their contact reaches
// the prebook payload empty. `attachInfantsToAdults` keeps CHILD as a standalone
// top-level passenger (only INFANT gets nested), so a supplier that requires
// per-passenger contact would reject the empty child email/phone. Fill ONLY the
// EMPTY child contact from the LEAD pax (index 0 = the primary adult, whose email
// + phone are required + validated before prebook). Never clobbers a filled value;
// ADULT + INFANT are returned unchanged (adult owns its contact; infant is nested
// off the `InfantData` contract, so its contact never reaches the backend).
export function fillChildContactFromLead(passengers: any[]) {
  try {
    if (!Array.isArray(passengers) || passengers.length === 0) return passengers;
    const lead = passengers.find((p) => p?.leadPax === true) ?? passengers[0];
    if (!lead) return passengers;
    return passengers.map((p) => {
      if (p?.paxType !== PAX_TYPE.child) return p;
      const emailEmpty = !p?.email || String(p.email).trim() === "";
      const phoneEmpty = !p?.mobileNumber || String(p.mobileNumber).trim() === "";
      if (!emailEmpty && !phoneEmpty) return p;
      return {
        ...p,
        ...(emailEmpty ? { email: lead?.email ?? p?.email } : {}),
        // A phone number is only valid paired with its own country code, so copy
        // the lead's countryCode/countryName/iso together with the number.
        ...(phoneEmpty
          ? {
              mobileNumber: lead?.mobileNumber ?? p?.mobileNumber,
              countryCode: lead?.countryCode ?? p?.countryCode,
              countryName: lead?.countryName ?? p?.countryName,
              iso: lead?.iso ?? p?.iso,
            }
          : {}),
      };
    });
  } catch {
    return passengers;
  }
}